exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#special-conditions.dropzone[data-v-76693cb3]:before {\n    content: 'Tr\\E6k og slip vilk\\E5r hertil';\n    position: relative;\n    width: 100%;\n    display: block;\n    text-align: center;\n    top: 10px;\n    font-family: HankenGroteskSemiBold, HankenGroteskSemiBoldOld, HelveticaNeue, Helvetica, Arial, sans-serif;\n    color: #1c073e;\n}\n", ""]);

// exports
